<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t(`${method_payment} Details`) }}</h3>
                <span class="fz-16 fw-400">Detail information your {{ method_payment.toLowerCase() }} history</span>
            </div>

        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="text-center">
                <img :src="`${publicPath}/img/gep/icon/summary.svg`" width="100px" class="icon-summary mt-3 mb-2">
                <div class="fz-16 fw-600 text-grey7 mb-2">{{ method_payment }} Details</div>
                <div class="fz-36 fw-600">{{ currency }} {{ getPrince(amount + fee) }}</div>
                <hr class="dashed">
                <div class="d-flex flex-column px-3">
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Merchant Number</span>
                        <span class="ml-auto fw-600">{{ orderId }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Payment Time</span>
                        <span class="ml-auto fw-600">{{ createAt }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Payment Method</span>
                        <span class="ml-auto fw-600">{{ method_payment }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Recipient Name</span>
                        <span class="ml-auto fw-600">{{ recipientName }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Recipient Number</span>
                        <span class="ml-auto fw-600">{{ recipient }}</span>
                    </div>
                </div>
                <hr class="dashed">
                <div class="d-flex flex-column px-3">
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Amount</span>
                        <span class="ml-auto fw-600">{{ currency }} {{ getPrince(amount) }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Processing Fee</span>
                        <span class="ml-auto fw-600">{{ currency }} {{ getPrince(fee) }}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-grey7 fz-16">Total</span>
                        <span class="ml-auto fw-600">{{ currency }} {{ getPrince(amount + fee) }}</span>
                    </div>
                </div>
                <div class="text-right">
                    <button class="btn btn-primary my-3" @click="backTo()">Back to
                        {{ method_payment }}</button>
                </div>
            </div>
        </b-container>
        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>
import Vue from 'vue';
import LoaderComponent from "@/components/LoaderComponent";
import stepContainer from "@/components/CardManagement/stepContainer";
import MaskAmount from "@/components/Mask/MaskAmount";
import CurrencyService from '@/services/CurrencyService';
import Account from '@/services/Account';
import Global from '@/services/Global';

export default {
    name: 'account-opening',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            recipient: '',
            recipientName: '',
            user_no: '',
            orderId: '',
            amount: 0,
            currency: '',
            fee: 0,
            createAt: '',
            method_payment: '',

        }
    },
    components: {
        LoaderComponent,
        stepContainer,
        MaskAmount
    },
    methods: {
        backTo() {
            if (this.method_payment == 'Transfer') {
                this.$router.push({ path: '/transfer' });
            } else {
                this.$router.push({ path: '/consolidation' });
            }
        },
        getPrince(price) {
            return Global.addCommas(price);
        },
        checkError(err) {
            try {
                this.isLoading = false;
                const response = err.response;
                if (response.status == 400) {
                    const data = response.data.data.response;
                    if (data['errorMsg']) {
                        this.$notify({
                            type: 'warn',
                            text: data['errorMsg']
                        });
                    }
                    else if (typeof data === 'string') {
                        this.$notify({
                            type: 'warn',
                            text: data
                        });
                    }
                    else {
                        let ret = [];
                        Object.keys(data).forEach((key) => {
                            ret.push(data[key][0]);
                        });

                        this.$notify({
                            type: 'warn',
                            html: ret.join("<br>")
                        });
                    }
                }
                else if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: '/login',
                    });
                }
                else {
                    if (localStorage.getItem("token")) {
                        var msg = (response.data) ? response.data.message : err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            } catch (e) {
                console.log(err);
            }
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.user_no = this.$route.query.user_no;
            self.recipient = this.$route.query.recipient;
            self.recipientName = this.$route.query.recipientName;
            self.method_payment = this.$route.query.method_payment;

            Account.transferDetail({ "userNo": this.$route.query.user_no, "userReqNo": this.$route.query.user_req_no }).then(response => {
                if (response.status == 200) {
                    const data = response.data.data.response.data;
                    this.orderId = data.orderId;
                    this.amount = data.payeeAmt;
                    this.currency = data.payeeCcy;
                    this.createAt = data.createAt;
                }
            });
        });
    }
};
</script>

<style>
.dashed {
    border-top: 2px dashed #D1D4D7;
}

.icon-summary {
    border-radius: 20px;
    background: #EDF8F1;
}
</style>